import { AsyncPipe, NgIf } from '@angular/common';
import { Component, DestroyRef, OnInit } from '@angular/core';
import {
  FormFieldComponent,
  FormFieldDirective,
  FormRowComponent,
  FormSubmitButtonComponent,
} from '@domgen/dgx-fe-forms/layout';
import { FormSubmitDirective } from '@domgen/dgx-fe-forms/shared';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';
import { filterNullUndefined } from '@domgen/dgx-fe-common';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { SmartFixHubBreadcrumbsComponent } from '../smart-fix-hub-breadcrumbs/smart-fix-hub-breadcrumbs.component';
import { SearchInputComponent } from '@domgen/dgx-fe-forms/input';
import { GAContainerDirective, GAFormSubmitDirective } from '@domgen/dgx-fe-ga';
import { ArticleSearchService } from '@self-fix/data-access';
import { ArticleSearchFormValue } from '@self-fix/util-models';
import { ArticleSearchFormComponentService } from '../../services/article-search-form-component/article-search-form-component.service';
import { SmartFixHubAnalyticsService } from 'libs/self-fix/data-access/src/lib/services/sf-hub-analytics/sf-hub-analytics-service';
import { Router } from '@angular/router';
import { BreadcrumbsComponent } from '@domgen/dgx-fe-components/navigation';

@Component({
  selector: 'dg-breadcrumb-search-bar',
  standalone: true,
  providers: [ArticleSearchFormComponentService],
  imports: [
    AsyncPipe,
    SmartFixHubBreadcrumbsComponent,
    FormFieldComponent,
    FormFieldDirective,
    FormRowComponent,
    FormSubmitButtonComponent,
    FormSubmitDirective,
    GAContainerDirective,
    GAFormSubmitDirective,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    NgIf,
    ReactiveFormsModule,
    SearchInputComponent,
    BreadcrumbsComponent,
  ],
  templateUrl: './breadcrumb-search-bar.component.html',
  styleUrls: ['./breadcrumb-search-bar.component.scss'],
})
export class BreadcrumbSearchBarComponent implements OnInit {
  constructor(
    readonly cs: ArticleSearchFormComponentService,
    private readonly articleSearchService: ArticleSearchService,
    private readonly destroyRef: DestroyRef,
    private smartFixAnalytics: SmartFixHubAnalyticsService,
    private router: Router
  ) {}
  ngOnInit(): void {
    this.cs.buildForm();
    this.articleSearchService.searchTerm$
      .pipe(takeUntilDestroyed(this.destroyRef), filterNullUndefined())
      .subscribe((searchTerm) => {
        this.cs.form.setValue({ search: searchTerm });
      });
  }

  isOnDashboardPage = this.router.url.includes('/appliance-details');

  onFormSubmit(formValue: ArticleSearchFormValue): void {
    this.cs.submit(formValue.search);
    this.smartFixAnalytics.trackEvent({
      eventCategory: 'sf-hub',
      eventAction: 'search box - usage',
      eventLabel: formValue.search,
      event: 'genericGAEvent',
      pagename: this.isOnDashboardPage
        ? 'claims-sf-hub-dashboard'
        : 'claims-sf-hub-your-appliance',
    });
  }
}
